var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { styleNames } from '../../propTypes/commonComponent';
import APIcon from '../common/APIcon';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import APInput from '../common/APInput';
import APButton from '../common/APButton';
import { required, matchingPassword } from '../../helpers/formValidations';
import passwordScore from '../../helpers/passwordScore';
import path from '../../helpers/path';
import StandAloneLayout from '../../layouts/StandAloneLayout/StandAloneLayout';
import '../../styles/components/common/StandaloneForm.css';
import './ResetPasswordFormComponent.css';
var baseClasses = getBEMClasses('standalone-form');
var resetPasswordClasses = getBEMClasses('reset-password');
var ResetPasswordFormComponent = function (_React$Component) {
  _inherits(ResetPasswordFormComponent, _React$Component);
  function ResetPasswordFormComponent() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, ResetPasswordFormComponent);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResetPasswordFormComponent.__proto__ || Object.getPrototypeOf(ResetPasswordFormComponent)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function () {
      if (_this.props.validateError) {
        _this.props.clearResetPasswordError();
      }
    }, _this.getPasswordStrength = function () {
      var _this2 = _this,
        context = _this2.context;
      var score = passwordScore(_this.props.passwordValue);
      var passwordStrengthValues = {
        0: context.t('Very Weak'),
        1: context.t('Weak'),
        2: context.t('Medium'),
        3: context.t('Strong'),
        4: context.t('Very Strong')
      };
      return passwordStrengthValues[score];
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(ResetPasswordFormComponent, [{
    key: 'render',
    value: function render() {
      var context = this.context,
        _props = this.props,
        processingResetPassword = _props.processingResetPassword,
        message = _props.message,
        handleSubmit = _props.handleSubmit,
        fetchError = _props.fetchError,
        pristine = _props.pristine,
        passwordValue = _props.passwordValue,
        invalid = _props.invalid,
        validateError = _props.validateError;
      return React.createElement(StandAloneLayout, null, React.createElement('div', {
        className: baseClasses('container') + ' ' + resetPasswordClasses('container')
      }, !message && React.createElement('div', {
        className: baseClasses('header') + ' ' + resetPasswordClasses('header')
      }, React.createElement('div', {
        className: '' + baseClasses('header-text')
      }, context.t('Reset Your Password')), React.createElement(Link, {
        to: path('/'),
        className: baseClasses('close-icon')
      }, React.createElement(APIcon, {
        name: 'close',
        classModifiers: 'big'
      }))), !message && React.createElement('form', {
        onSubmit: handleSubmit,
        className: '' + baseClasses('form')
      }, React.createElement(APInput, {
        type: 'password',
        name: 'password',
        customClass: resetPasswordClasses(),
        label: context.t('New Password'),
        validate: [required],
        readOnly: processingResetPassword,
        info: passwordValue && React.createElement('span', {
          className: baseClasses('password-strength')
        }, this.getPasswordStrength()),
        onChange: this.handleChange
      }), React.createElement(APInput, {
        type: 'password',
        name: 'matchingPassword',
        customClass: resetPasswordClasses(),
        label: context.t('Repeat New Password'),
        readOnly: processingResetPassword,
        validate: [required],
        onChange: this.handleChange
      }), validateError && React.createElement('div', {
        className: baseClasses('password-error')
      }, validateError), React.createElement('hr', {
        className: '' + resetPasswordClasses('separator')
      }), React.createElement(APButton, {
        type: 'submit',
        disabled: pristine || processingResetPassword || invalid,
        customClass: '' + resetPasswordClasses(),
        styleName: styleNames.additive
      }, processingResetPassword ? context.t('Resetting your password...') : context.t('Reset Password'))), message && React.createElement(React.Fragment, null, React.createElement('div', {
        className: '' + baseClasses('message')
      }, React.createElement('div', {
        className: '' + baseClasses('message-text')
      }, context.t(message))), React.createElement('div', {
        className: '' + baseClasses('message-footer')
      }, fetchError ? React.createElement(Link, {
        to: path('/problem-logging-in'),
        className: baseClasses('btn', 'subtractive')
      }, context.t('Problem resetting your password?')) : React.createElement(Link, {
        to: path('/login'),
        className: baseClasses('btn', 'additive')
      }, context.t('Go to Exchange'))))));
    }
  }]);
  return ResetPasswordFormComponent;
}(React.Component);
ResetPasswordFormComponent.defaultProps = {
  handleSubmit: function handleSubmit() {},
  processingResetPassword: false,
  message: '',
  fetchError: false
};
ResetPasswordFormComponent.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  processingResetPassword: PropTypes.bool.isRequired,
  fetchError: PropTypes.bool
};
ResetPasswordFormComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
export default ResetPasswordFormComponent;